import { ChevronLeft, ChevronRight } from "lucide-react";
import Row from "./Row";
import Button from "./Button";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  return (
    <Row className="justify-center mt-4">
      <Button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        backgroundColor="white"
        px="px-2"
        py="py-2"
      >
        <ChevronLeft className="w-5 h-5" />
      </Button>
      <span className="text-sm text-gray-700">
        Page {currentPage} of {totalPages}
      </span>
      <Button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        backgroundColor="white"
        px="px-2"
        py="py-2"
      >
        <ChevronRight className="w-5 h-5" />
      </Button>
    </Row>
  );
}
